import React from 'react';
import ImageNavigationItem from 'Components/Navigation/ImageNavigation/ImageNavigationItem/image-navigation-item';
import RecruitingView from '../RecruitingView/RecruitingView';
import './Index.scss';
import ImagePageTitle from '../../../components/common/image-page-title/ImagePageTitle';

function Index() {
  return (
    <div>
      <div className="page-header">
        {/*<ImageNavigationItem*/}
        {/*  active*/}
        {/*  title="Onboarding"*/}
        {/*  image="/images/Recruiting.jpg"*/}
        {/*      />*/}
        <ImagePageTitle image="/images/Recruiting.jpg" title="Onboarding" />
      </div>
      <div className="page-content">
        <RecruitingView />
      </div>
    </div>
  );
}

export { Index };
